document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('subscription-popup');
    var closeButton = document.querySelector('.close-popup');
    var form = document.getElementById('subscription-form');
    var popupResponse = document.getElementById('popup-response');

    // Check if the popup has already been shown during this session
    if (!sessionStorage.getItem('popupShown')) {
        // Show popup after a delay (e.g., 5 seconds)
        setTimeout(function () {
            popup.style.display = 'block';
            sessionStorage.setItem('popupShown', 'true');  // Set the flag in session storage
        }, 5000);  // 5000 milliseconds = 5 seconds
    }

    // Close popup when clicking the close button
    closeButton.addEventListener('click', function () {
        popup.style.display = 'none';
    });

    // Close popup when clicking outside of the popup content
    window.addEventListener('click', function (e) {
        if (e.target === popup) {
            popup.style.display = 'none';
        }
    });

    // Handle form submission without reloading the page
    form.addEventListener('submit', function (e) {
        // After form submission, display success message in popup response
        var iframe = document.querySelector('iframe[name="hidden-iframe"]');

        // Add event listener to the iframe load event to catch form submission
        iframe.addEventListener('load', function () {
            // If submission was successful, show thank you message
            popupResponse.innerHTML = '<div class="popup-alert popup-success">Thank you for signing up.</div>';

            // Automatically hide the popup after 2 seconds
            setTimeout(function () {
                popup.style.display = 'none';
            }, 2000);  // 2000 milliseconds = 2 seconds
        });
    });
});
